import { Component, Input, Output, EventEmitter } from '@angular/core';
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Observable } from 'rxjs';
import { WorkOrderBase } from 'src/app/CommonFiles/BusinessModels';
import { SharedUtilService } from 'src/app/CommonFiles/utilities/shared-util.service';
import { InstallDateErrorDto, InstallDateResultDto, InstalldDateGRPCService, WorkOrderInstallDateDto } from 'src/app/ProxyServices/installdate.grpc.service';

@Component({
    standalone: false,
    selector: 'install-date-popup',
    templateUrl: './install-date-popup.component.html',
    styleUrls: ['./install-date-popup.component.scss']
})

export class InstallDatePopupComponent {
    faTimes = faTimes;
    faCheck = faCheck;
    
    public installdate: Date = new Date(Date.now());
    public mindate: Date = new Date(Date.now());
    public remove: boolean = false;
    public computed: WorkOrderBase[] = [];
    public isExecuting: boolean = false;
    public errors: InstallDateErrorDto[] = [];
    public isAll: boolean = false;

    @Input() show: boolean;
    @Input() total: number;
    @Input() public workorders: any[];
    @Input() public contractname: string;
    @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() completedEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private installDateGrpcService: InstalldDateGRPCService,private sharedUtilService:SharedUtilService) { }

    onSave() {
        const picked = this.installdate;
        let date = this.remove
            ? new Date(Date.now())
            : new Date(Date.UTC(picked.getFullYear(), picked.getMonth(), picked.getDate(), 0, 0, 0, 0));
        this.isExecuting = true;
        this.errors = [];

        let resultObs: Observable<InstallDateResultDto[]> = this.installDateGrpcService
            .set({ workorders: this.workorders.map(x => { return { name: x.name, contractname: x.contractname, servicetype: x.servicetype } as WorkOrderInstallDateDto; }), date: date, remove: this.remove, all: this.isAll });
           
        resultObs.subscribe(r => {
            let result = r[r.length - 1];
            this.computed = result?.computed;
            
            if (result?.error.filter(er => !er.message.includes("blackout")).length > 0) {
                this.errors = result.error;
                this.sharedUtilService.handleBackendResponse(JSON.stringify(this.errors),this.computed);
            }

            this.isExecuting = false;
            
            this.completedEvent.emit(this.computed);
            
            if (this.errors.length == 0)
                this.onClose();
        });


    }
    public getProgressBarMaxValue() {
        return this.isAll ? this.total : this.workorders.length;
    }

    onClose() {
        this.installdate = new Date(Date.now());
        this.remove = false;
        this.computed = [];
        this.isAll = false;

        this.isExecuting = false;
        this.errors = [];
        this.closeEvent.emit(false);
    }
}